import { render } from "./detail-setting-games.vue?vue&type=template&id=0c0cd086"
import script from "./detail-setting-games.vue?vue&type=script&lang=js"
export * from "./detail-setting-games.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__